import { render, staticRenderFns } from "./home-memu.vue?vue&type=template&id=3b9b0473&scoped=true&"
import script from "./home-memu.vue?vue&type=script&lang=js&"
export * from "./home-memu.vue?vue&type=script&lang=js&"
import style0 from "./home-memu.vue?vue&type=style&index=0&id=3b9b0473&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9b0473",
  null
  
)

export default component.exports